import {
  SET_USERS,
  SET_DASHBOARD_FILTER,
  SET_DASHBOARD_TARGET_FILTER,
  SET_DATASETS,
  SET_BYOD_DATASET,
  SET_PRIMARY_INSIGHTS_FILTER,
  SET_DATASET_FAMILIES,
  SET_DAY_PARTS,
  SET_QUICK_ADD_ATTRIBUTES,
  SET_DATE_RANGE,
  SET_SOURCE_CONSTANTS,
  SET_MVPDS,
  SET_VIDEOAMP_AUDIENCE_LIST,
} from './constants'
import UserAPI from '@/api/UserAPI'
import transformAttributes from '@/appLogic/workbench/common/attributeTransformation'
import ConfigAPI from '@/api/ConfigAPI'
import XandrApi from '@/api/XandrAPI'
import DataCityApi from '@/api/DataCityAPI'
import { fetchEsDateRanges } from '@/api'

/**
 * AMRLD is special because amrld as a dataset for any attribute will not cut it
 * we need to have the houself, shows, and respondents as the dataset not amrld
 * because of this we need to have this restructuring of the data
 */
const transformAmrld = function (datasets) {
  let AMRLDDataset = datasets.filter(d => d.id === 'amrld')[0]
  let childrenOfAmrld = AMRLDDataset.children.map(d => Object.freeze(transformAttributes(d, d.id, 'amrld')))
  let combinedFlat = []
  for (let c of childrenOfAmrld) {
    combinedFlat.push.apply(combinedFlat, c.flat.attributes)
  }
  let newAmrldRoot = {
    data: {
      children: childrenOfAmrld.map(d => d.data),
      id: 'amrld',
      name: 'AMRLD',
    },
    flat: { name: 'AMRLD', attributes: combinedFlat },
  }
  return newAmrldRoot
}

const actions = {
  [SET_USERS](context) {
    if (context.state.users.length === 0) {
      UserAPI.getUsers().then(users => {
        context.commit(SET_USERS, users)
      })
    }
  },
  [SET_DATASETS](context) {
    const traitTypes = context.state.sourceConstants ? context.state.sourceConstants.TRAIT_TYPE : null
    const reqs = [
      ConfigAPI.fetchAllWorkbenchConfigs(traitTypes),
      ConfigAPI.fetchDatasetFamilies(),
      ConfigAPI.getConfigFilesForConfigType('las').fetchConfig(),
      fetchEsDateRanges(),
    ]
    Promise.all(reqs).then(async resp => {
      const [datasets, datasetFamilies, lasConfig, dateRangeResponse] = resp
      console.log('fetching target date range...')
      // AMRLD is treated as a special case because of the housold, shows, and respondent ids are needed in the API
      // calls to get the data.  This is tied to the dataset propery of the attributes selected in the target definition
      const newAmrldRoot = transformAmrld(datasets)
      // remove the amrld dataset and empty dataset from the list of datasets
      const nonAmrldDatasets = datasets.filter(d => d.id !== 'amrld' && d.children.length > 0)
      const byodDataset = datasets.find(d => d.id === 'byod')
      let transformedAttributes = nonAmrldDatasets.map(d => Object.freeze(transformAttributes(d, d.id, d.id)))
      // keeps the datasets in sorted order
      transformedAttributes = [newAmrldRoot, ...transformedAttributes]
      transformedAttributes.sort((a, b) => a.data.name.toLowerCase().localeCompare(b.data.name.toLowerCase()))

      context.commit(SET_DATASETS, transformedAttributes)
      context.commit(SET_BYOD_DATASET, byodDataset)
      context.commit(SET_QUICK_ADD_ATTRIBUTES, lasConfig.quick_add)
      context.commit(SET_DATASET_FAMILIES, datasetFamilies)
      context.commit(SET_DAY_PARTS, lasConfig.day_parts)
      context.commit(SET_DATE_RANGE, dateRangeResponse)
    })
  },
  [SET_PRIMARY_INSIGHTS_FILTER](context) {
    if (Object.keys(context.state.primaryInsightsFilter).length === 0) {
      XandrApi.getPrimaryInsightsConfig().then(primaryInsightsFilter => {
        context.commit(SET_PRIMARY_INSIGHTS_FILTER, primaryInsightsFilter)
      })
    }
  },
  [SET_DASHBOARD_FILTER]: (context, filter) => {
    context.commit(SET_DASHBOARD_FILTER, filter)
  },
  [SET_DASHBOARD_TARGET_FILTER]: (context, value) => {
    context.commit(SET_DASHBOARD_TARGET_FILTER, value)
  },
  [SET_SOURCE_CONSTANTS]: context => {
    return XandrApi.getDatasourcesConfig()
      .then(constants => {
        context.commit(SET_SOURCE_CONSTANTS, constants)
      })
      .catch(err => {
        console.error(`Error getting datasources config: ${err}`)
      })
  },
  [SET_MVPDS]: context => {
    DataCityApi.getMVPDs().then(resp => {
      context.commit(SET_MVPDS, resp)
    })
  },
  [SET_VIDEOAMP_AUDIENCE_LIST]: context => {
    XandrApi.getVideoAmpAudienceList()
      .then(audienceList => {
        const formattedList = audienceList.map(item => ({
          id: item.VA_AUDIENCE_ID,
          name: `${item.VA_AUDIENCE_ID} - ${item.VA_AUDIENCE_NAME}`,
          disabled: item.selected,
        }))
        context.commit(SET_VIDEOAMP_AUDIENCE_LIST, formattedList)
      })
      .catch(err => {
        console.error(`Error getting VideoAmp audience list: ${err}`)
      })
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/store/modules/applicationResources/actions.js